export enum RecommendationMethodology {
	CSL = 1,
	DOH = 2,
}
